// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"396":"5a4c6657","453":"097b5ed4"}[chunkId] + ".chunk.js";
};